import React from "react";
import {H1, Icon, Button, FlexRow} from "@reside/ui";
import {downloadPdf} from "../hooks/useGeneratePdf";
import {DocumentPreviewBarContainer} from "./styles";
import {DocumentPreviewBarProps} from "../types";
import {getWorkflowPacketLabel} from "../../start-workflow/workflowMapping";

export const DocumentPreviewBar = ({
  pdfDocumentName,
  isLoadingPdf,
  file,
  isGenerating,
  workflowLabel = "Admission",
}: DocumentPreviewBarProps) => {
  return (
    <DocumentPreviewBarContainer>
      <FlexRow style={{alignItems: "center"}}>
        <H1 fontSize={[3, 5]}>
          Download {getWorkflowPacketLabel(workflowLabel)}
        </H1>

        <Button
          color="primary"
          onClick={() => downloadPdf(file, pdfDocumentName)}
          disabled={isLoadingPdf || isGenerating}
        >
          Download {workflowLabel} <Icon name="download" />
        </Button>
      </FlexRow>
    </DocumentPreviewBarContainer>
  );
};
